(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('@charset "UTF-8";.v-dialog,.v-dialog-lite{position:fixed;z-index:1050;outline:0}.v-dialog-lite{left:0;right:0}.v-dialog{position:fixed}.v-dialog.v-dialog--content-center{display:flex;justify-content:center;align-items:center}.v-dialog.v-dialog--screen-center{left:50%;top:50%;transform:translate(-50%,-50%)}.v-dialog.v-dialog--horizontal-center{left:50%;transform:translate(-50%)}.v-dialog.v-dialog--embedded{position:absolute}.v-dialog .v-dialog-content{outline:0;position:relative;background-color:#fff;box-shadow:0 3rem 5rem #00000080;border-radius:1rem;border:0;overflow:hidden;display:flex;flex-direction:column;transition:all .2s ease-out}.v-dialog .v-dialog-header{display:flex;align-items:center;flex-shrink:0;height:42px}.v-dialog .v-dialog-header h3{margin:0;font-size:18px;padding:0 15px;font-weight:500;flex-grow:1;color:#666;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.v-dialog .v-dialog-body{position:relative;width:100%;padding:0;overflow:auto;box-sizing:border-box;flex-grow:1}.v-dialog-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#00000080}.v-dialog-overlay.v-dialog-overlay--blur{-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}.v-dialog-overlay.v-dialog-overlay--embedded{position:absolute}.v-dialog-icon{display:inline-flex;width:1em;height:1em}@keyframes soft-candy-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}to{transform:scale(1)}}.v-dialog--candy-enter-active{animation:soft-candy-show .3s ease-out}.v-dialog--candy-leave-active{transform:scale(.5);transition:transform .2s linear,opacity .2s linear;opacity:0}.v-dialog--smooth-enter-active,.v-dialog--smooth-leave-active{transition:transform .25s ease-in-out,opacity .15s ease-in-out!important}.v-dialog--smooth-enter-from,.v-dialog--smooth-leave-to{transform:scale(.5);opacity:0}.v-dialog--fade-enter-active,.v-dialog--fade-leave-active{will-change:opacity;transition:opacity .3s cubic-bezier(.4,0,.2,1)}.v-dialog--fade-enter-from,.v-dialog--fade-leave-to{opacity:0}.v-dialog--fade-lite-enter-active,.v-dialog--fade-lite-leave-active{transition:opacity .3s ease-in-out}.v-dialog--fade-lite-enter-from,.v-dialog--fade-lite-leave-to{opacity:0}@keyframes animated-buzz-out{10%{transform:translate(3px) rotate(2deg)}20%{transform:translate(-3px) rotate(-2deg)}30%{transform:translate(3px) rotate(2deg)}40%{transform:translate(-3px) rotate(-2deg)}50%{transform:translate(2px) rotate(1deg)}60%{transform:translate(-2px) rotate(-1deg)}70%{transform:translate(2px) rotate(1deg)}80%{transform:translate(-2px) rotate(-1deg)}90%{transform:translate(1px) rotate(0)}to{transform:translate(-1px) rotate(0)}}.v-dialog--buzz-out{animation-name:animated-buzz-out;animation-duration:.75s;animation-timing-function:linear;animation-iteration-count:1}.v-dialog-modal{left:0;right:0;top:0;bottom:0}.v-dialog-modal.v-dialog-modal--maximize{padding-right:0!important}.v-dialog-modal.v-dialog-modal--maximize .v-dialog-content{width:100vw!important;height:100vh!important;border-radius:0}.v-dialog-modal.v-dialog-modal--maximize .v-dialog-header{background-color:#eee}.v-dialog-modal .v-dialog-content{border-radius:.5rem;transition:width .2s ease-in-out,height .2s ease-in-out;min-width:400px;min-height:200px}.v-dialog-modal .v-dialog-content .v-dialog-header button{width:60px;height:100%;transition:all .3s ease-out;text-shadow:none;outline:none!important;margin:0;opacity:.3;font-size:18px!important;border:0;background-color:transparent;display:inline-flex;justify-content:center;align-items:center;flex-shrink:0}.v-dialog-modal .v-dialog-content .v-dialog-header button:hover{opacity:1}.v-dialog-modal .v-dialog-content .v-dialog-header button.v-dialog-btn__close{font-weight:400}.v-dialog-modal .v-dialog-content .v-dialog-header button.v-dialog-btn__close:hover{background-color:#e81123;color:#fff}.v-dialog-modal .v-dialog-content .v-dialog-header button.v-dialog-btn__maximize:hover{background-color:#e0e0e0}.v-dialog-modal .v-dialog-content .v-dialog-body{padding:0!important}.v-dialog-mask{left:0;right:0;top:0;bottom:0}.v-dialog-mask .v-dialog-content.mask--pill{border-radius:50rem}.v-dialog-mask .v-dialog-content.mask--no-icon .v-dialog-mask__content{margin-left:2rem!important}.v-dialog-mask .v-dialog-content.mask--no-panel{box-shadow:none!important;background-color:transparent}.v-dialog-mask .v-dialog-body{overflow:hidden!important;display:flex;align-items:center;min-width:300px;max-width:400px;color:#333}.v-dialog-mask .v-dialog-body .v-dialog-mask__content,.v-dialog-mask .v-dialog-body .v-dialog-mask__icon{display:flex;align-items:center}.v-dialog-mask .v-dialog-body .v-dialog-mask__content{margin:0 1.5rem 0 1rem;font-size:1rem;line-height:1.3;overflow-y:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;text-overflow:ellipsis}.v-dialog-mask .v-dialog-body .v-dialog-mask__icon{padding-left:17px;flex-shrink:0}.v-dialog-mask .v-dialog-body .v-dialog-icon-loading{font-size:2rem}.v-dialog-mask-parent--relative{position:relative!important}.v-dialog-drawer.v-dialog-drawer--top{top:0;left:0}.v-dialog-drawer.v-dialog-drawer--bottom{bottom:0;left:0}.v-dialog-drawer.v-dialog-drawer--left{top:0;left:0}.v-dialog-drawer.v-dialog-drawer--right{top:0;right:0}.v-dialog-drawer .v-dialog-content{border-radius:0;min-width:400px;min-height:200px}.v-dialog-drawer .v-dialog-content .v-dialog-header button{width:60px;height:100%;transition:all .3s ease-out;text-shadow:none;outline:none!important;margin:0;opacity:.3;font-size:18px!important;border:0;background-color:transparent;display:inline-flex;justify-content:center;align-items:center}.v-dialog-drawer .v-dialog-content .v-dialog-header button:hover{opacity:1}.v-dialog-drawer .v-dialog-content .v-dialog-header button.v-dialog-btn__close{font-weight:400}.v-dialog-drawer .v-dialog-content .v-dialog-header button.v-dialog-btn__close:hover{background-color:#e81123;color:#fff}.v-dialog-drawer .v-dialog-content .v-dialog-body{padding:0!important}.v-dialog-drawer-slide-in-top-enter-active,.v-dialog-drawer-slide-in-top-leave-active{transition:transform .25s ease-in-out,opacity .25s linear}.v-dialog-drawer-slide-in-top-enter-from,.v-dialog-drawer-slide-in-top-leave-to{transform:translateY(-100%);opacity:0}.v-dialog-drawer-slide-in-bottom-enter-active,.v-dialog-drawer-slide-in-bottom-leave-active{transition:transform .25s ease-in-out,opacity .25s linear}.v-dialog-drawer-slide-in-bottom-enter-from,.v-dialog-drawer-slide-in-bottom-leave-to{transform:translateY(100%);opacity:0}.v-dialog-drawer-slide-in-left-enter-active,.v-dialog-drawer-slide-in-left-leave-active{transition:transform .25s ease-in-out,opacity .25s linear}.v-dialog-drawer-slide-in-left-enter-from,.v-dialog-drawer-slide-in-left-leave-to{transform:translate(-100%);opacity:0}.v-dialog-drawer-slide-in-right-enter-active,.v-dialog-drawer-slide-in-right-leave-active{transition:transform .25s ease-in-out,opacity .25s linear}.v-dialog-drawer-slide-in-right-enter-from,.v-dialog-drawer-slide-in-right-leave-to{transform:translate(100%);opacity:0}.v-dialog-alert{left:0;right:0;top:0;bottom:0}.v-dialog-alert.no-icon .v-dialog-alert__content{padding-left:15px}.v-dialog-alert.no-header .v-dialog-alert__content{padding-top:2rem}.v-dialog-alert .v-dialog-content{overflow:hidden;display:flex;flex-direction:column;background-color:#fff}.v-dialog-alert .v-dialog-footer{flex-shrink:0;overflow:hidden}.v-dialog-alert .v-dialog-footer .v-dialog-alert__buttons{display:flex;justify-content:flex-end;padding:0 1rem 1rem 0}.v-dialog-alert .v-dialog-footer .v-dialog-alert__buttons button{outline:none!important;padding:8px 15px;min-width:90px;border-radius:.7rem;font-size:14px;transition:all .2s ease-in-out;-webkit-user-select:none;-moz-user-select:none;user-select:none}.v-dialog-alert .v-dialog-footer .v-dialog-alert__buttons button:active{box-shadow:0 10px 20px #0003,0 6px 6px #0000003b}.v-dialog-alert .v-dialog-footer .v-dialog-alert__buttons .v-dialog-btn__ok{border:1px solid #516270;background-color:#516270;color:#fff}.v-dialog-alert .v-dialog-footer .v-dialog-alert__buttons .v-dialog-btn__cancel{border:1px solid #F0F0F0;background-color:#f0f0f0;margin-left:1rem}.v-dialog-alert .v-dialog-alert__content{overflow-y:auto;min-height:100px;flex-grow:1;display:flex;padding:1rem}.v-dialog-alert .v-dialog-alert__content .v-dialog-alert__icon{display:flex;padding:0 2rem 0 1rem;font-size:3rem;color:#333;filter:drop-shadow(4px 5px 5px rgba(0,0,0,.6))}.v-dialog-alert .v-dialog-alert__content .v-dialog-alert__message{flex-grow:1;font-size:14px;line-height:1.5;padding-top:5px}.v-dialog-alert .alert-warning .v-dialog-alert__icon{color:#ff9800;filter:drop-shadow(4px 5px 5px rgba(255,152,0,.8))}.v-dialog-alert .alert-error .v-dialog-alert__icon{color:#f44336;filter:drop-shadow(4px 5px 5px rgba(244,67,54,.8))}.v-dialog-alert .alert-success .v-dialog-alert__icon{color:#198754;filter:drop-shadow(4px 5px 5px rgba(25,135,84,.8))}.v-dialog-alert .alert-confirm .v-dialog-alert__icon{color:#3f51b5;filter:drop-shadow(4px 5px 5px rgba(63,81,181,.9))}.v-dialog__shadow--error{box-shadow:0 1rem 5rem #ff000080!important}.v-dialog__shadow--warning{box-shadow:0 1rem 5rem #ffa50080!important}.v-dialog__shadow--success{box-shadow:0 1rem 5rem #00ff0080!important}.v-dialog-message{background-color:transparent;overflow:unset;transition:all .3s;display:flex;justify-content:center;left:50%;right:unset;transform:translate(-50%)}.v-dialog-message .v-dialog-body{border-radius:1rem;box-shadow:0 2.5rem 8rem #000000e6;overflow:hidden;display:flex;align-items:center;background-color:#0006;-webkit-backdrop-filter:saturate(180%) blur(12px);backdrop-filter:saturate(180%) blur(12px);min-height:52px;max-width:500px}.v-dialog-message .v-dialog-body.v-dialog-message--pill{border-radius:2rem}.v-dialog-message .v-dialog-body.v-dialog-message--no-icon .v-dialog-message__body{padding:.5rem 2rem}.v-dialog-message .v-dialog-body.message-warning .v-dialog-message__prepend{color:#ff9800;filter:drop-shadow(4px 5px 5px rgba(255,152,0,.95))}.v-dialog-message .v-dialog-body.message-error .v-dialog-message__prepend{color:#f44336;filter:drop-shadow(4px 5px 5px rgba(244,67,54,.95))}.v-dialog-message .v-dialog-body.message-success .v-dialog-message__prepend{color:#198754;filter:drop-shadow(4px 5px 5px rgba(25,135,84,.95))}.v-dialog-message__prepend,.v-dialog-message__append{width:40px;flex-shrink:0;display:flex;align-items:center;font-size:1.3rem}.v-dialog-message__prepend{justify-content:flex-end;filter:drop-shadow(4px 5px 5px rgba(0,0,0,.95))}.v-dialog-message__append{justify-content:flex-start}.v-dialog-message__body{display:flex;align-items:center;font-size:14px;line-height:1.3;flex-grow:1;padding:.5rem 1rem;overflow:hidden;height:100%}.v-dialog-message__close{cursor:pointer}.v-dialog-toast{background-color:transparent;box-sizing:border-box;transition:all .3s}.v-dialog-toast .v-dialog-body{position:relative;display:flex;padding:1rem;box-shadow:0 5px 40px #0006;border-radius:.7rem;border-width:2px;border-style:solid;border-color:#ccc;color:#333;background-color:#fff;width:300px}.v-dialog-toast .v-dialog-body.toast-warning{border-color:#333;background-color:#f5cf87}.v-dialog-toast .v-dialog-body.toast-error{background-color:#ff5252;border-color:#bf2a2a;color:#fff}.v-dialog-toast .v-dialog-body.toast-error .v-dialog-toast__append{color:#ccc}.v-dialog-toast .v-dialog-body.toast-error .v-dialog-toast__append:hover{color:#fff}.v-dialog-toast .v-dialog-body.toast-success{background-color:#2cbe4e;border-color:#0a8427;color:#1b5e20}.v-dialog-toast .v-dialog-body.toast-success .v-dialog-toast__append{color:#666}.v-dialog-toast .v-dialog-body.toast-success .v-dialog-toast__append:hover{color:#000}.v-dialog-toast--left{left:16px;right:unset}.v-dialog-toast--right{left:unset;right:16px}.v-dialog-toast__prepend,.v-dialog-toast__append{display:flex;justify-content:center;flex-shrink:0}.v-dialog-toast__prepend{font-size:1.3rem}.v-dialog-toast__body{flex-grow:1;padding:0 10px;font-size:14px;overflow:hidden;min-height:60px}.v-dialog-toast__body h3{margin:0 0 3px;font-size:16px;font-weight:600}.v-dialog-toast__body div{font-size:14px;line-height:1.4;margin:0}.v-dialog-toast__append{color:#999;font-size:1rem;outline:none;transition:all .3s}.v-dialog-toast__append:hover{color:#000}.v-dialog-toast__close{cursor:pointer}')),document.head.appendChild(o)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import { ref as p, createVNode as o, mergeProps as de, getCurrentInstance as Je, render as we, isVNode as X, inject as C, h as Ae, onMounted as D, onUnmounted as Qe, computed as j, onBeforeMount as et, defineComponent as A, Teleport as ie, Transition as ce, openBlock as S, createElementBlock as x, createElementVNode as v, provide as H, watch as Se, markRaw as xe, nextTick as Me } from "vue";
const h = Symbol("props"), tt = "$dlg", nt = "v-dialogs-", ot = 5100, at = 50, lt = "100vw", st = "100vh", it = 450, ct = 210, Be = 32, rt = 15, ut = 16, Ie = 700, Oe = 400, R = "info", M = "warning", B = "error", I = "success", Y = "confirm", dt = 400, ft = 300, G = "top", fe = "bottom", gt = "left", J = "right", Le = "top-left", ne = "top-right", $e = "bottom-left", mt = "bottom-right", Pe = "close", re = "render-dialog", ue = "v-dialog-message-adjust-position", Te = [G, fe, gt, J], ht = [
  M,
  B,
  I
], ge = [
  M,
  B,
  I
], [
  vo,
  _o,
  me,
  yo,
  bo,
  he
] = ["modal", "alert", "toast", "drawer", "mask", "message"], Q = p(0), K = p([]), pt = new Event(ue);
function vt() {
  return Q.value++, nt + Q.value;
}
function z(e, t = {}, n) {
  var f;
  const { index: a, key: l } = We(n);
  let i = o(e, de(t, {
    dialogKey: l,
    dialogIndex: a,
    onClose: (d, m) => {
      d && d(m), u();
    }
  }));
  const c = ((f = Je()) == null ? void 0 : f.appContext) ?? null;
  i.appContext = c;
  let r = document.createElement("div");
  we(i, r);
  const u = () => {
    we(null, r), r = null, i = null, _t(l);
  };
  return () => {
    i.component.exposed.close();
  };
}
function We(e) {
  const t = vt();
  return K.value.push({
    key: t,
    index: Q.value,
    singletonKey: "",
    ...e
  }), {
    key: t,
    index: Q.value
  };
}
function _t(e) {
  K.value.length && (K.value = K.value.filter((t) => t.key !== e));
}
const [yt, ee, bt, Ct, Dt] = ["cn", "en", "pt", "jp", "tr"], se = {
  [yt]: {
    titleInfo: "提示",
    titleWarning: "警告",
    titleError: "错误",
    titleSuccess: "成功",
    titleConfirm: "确认",
    btnOk: "确认",
    btnCancel: "取消",
    maskText: "数据加载中……"
  },
  [ee]: {
    titleInfo: "Information",
    titleWarning: "Warning",
    titleError: "Error",
    titleSuccess: "Success",
    titleConfirm: "Confirmation",
    btnOk: "OK",
    btnCancel: "Cancel",
    maskText: "Loading……"
  },
  [bt]: {
    titleInfo: "Aviso",
    titleWarning: "Alerta",
    titleError: "Erro",
    titleSuccess: "Sucesso",
    titleConfirm: "Confirmaço",
    btnOk: "OK",
    btnCancel: "Cancelar",
    maskText: "Carregando……"
  },
  [Ct]: {
    titleInfo: "ヒント",
    titleWarning: "警告",
    titleError: "間違った",
    titleSuccess: "成功",
    titleConfirm: "確認",
    btnOk: "確認",
    btnCancel: "キャンセル",
    maskText: "データロード……"
  },
  [Dt]: {
    titleInfo: "Bilgi",
    titleWarning: "Uyarı",
    titleError: "Hata",
    titleSuccess: "Başarılı",
    titleConfirm: "Onay",
    btnOk: "Evet",
    btnCancel: "İptal",
    maskText: "Yükleniyor"
  }
}, kt = {
  /** Dialog key */
  dialogKey: { type: String, default: "" },
  dialogIndex: { type: Number, required: !0 },
  singletonKey: { type: String, default: "" },
  customClass: { type: String, default: "" },
  /** Display dialog backdrop */
  backdrop: { type: Boolean, default: !0 },
  /** Click backdrop to close dialog */
  backdropClose: { type: Boolean, default: !1 },
  /** Display dialog header */
  header: { type: Boolean, default: !0 },
  title: { type: String, default: "" },
  message: { type: [String, Object], default: "" },
  /** Dialog width */
  width: { type: Number, default: 0 },
  /** Dialog height */
  height: { type: Number, default: 0 },
  shake: { type: Boolean, default: !1 },
  language: { type: String, default: ee },
  callback: { type: Function, default: void 0 }
}, wt = [Pe, re], Tt = {
  backdrop: !0
}, Et = {
  backdrop: !0,
  backdropClose: !1
}, At = {
  backdrop: !0,
  backdropClose: !1,
  shake: !1
}, St = {
  shake: !1
};
function F(e) {
  return { ...kt, ...e };
}
function V(e = []) {
  return [...wt, ...e];
}
function Ne(e, t) {
  switch (e) {
    case M:
      return t.titleWarning;
    case B:
      return t.titleError;
    case I:
      return t.titleSuccess;
    case Y:
      return t.titleConfirm;
    default:
      return t.titleInfo;
  }
}
function U(e, t, n) {
  if (typeof t == "object" && typeof n == "object" || typeof t == "function" && typeof n == "function") {
    console.warn("Invalid parameters for v-dialogs");
    return;
  }
  const a = Array.from(arguments), l = a.find((s) => typeof s == "object" && !X(s) && !Ee(s)) || {};
  return l.message = a.find((s) => typeof s == "string" || X(s) || Ee(s)) || "", l.callback = a.find((s) => typeof s == "function"), l;
}
function Ee(e) {
  return typeof e != "object" ? !1 : !!(Object.hasOwn(e, "render") || Object.hasOwn(e, "template") || Object.hasOwn(e, "setup"));
}
function xt(e) {
  return typeof e != "object" ? !1 : !!(Object.hasOwn(e, "tagName") || Object.hasOwn(e, "tagName") && e.outerHTML);
}
function Mt(e) {
  return ((window.innerHeight || document.documentElement.clientHeight) - e) / 2;
}
function Bt(e) {
  const t = ot + at * e, n = t - 10;
  return { dialogZIndex: t, backdropZIndex: n };
}
function pe(e = ee) {
  const t = String(e).toLowerCase();
  return t in se ? se[t] : se[ee];
}
function It() {
  return document.body.scrollHeight > window.innerHeight;
}
function Ot() {
  if (!It() || document.body.style.overflowY === "hidden") return;
  const e = document.documentElement.clientWidth, t = window.innerWidth - e;
  document.body.style.paddingRight = `${t}px`, document.body.style.overflowY = "hidden";
}
function Lt() {
  document.body.style.removeProperty("overflow-y"), document.body.style.removeProperty("padding-right");
}
function q(e, t = "px") {
  return typeof e == "number" ? `${e}${t}` : e;
}
function ve(e, t, n, a) {
  const l = {};
  return e.forEach((s) => {
    const [i, ...c] = s, r = t + i.toUpperCase() + c.join("");
    l[r] = function() {
      const u = {
        ...U(...arguments),
        messageType: s
      }, f = a && a(u);
      return z(n, u, f);
    };
  }), l;
}
function $t(e) {
  const {
    component: t,
    params: n,
    closeDialogWithCallback: a
  } = C(h);
  function l() {
    if (e.default) return e.default();
    if (!t) return;
    const s = typeof t == "function" ? t() : t;
    return Ae(s, de(n, {
      onClose: (c) => a(c)
    }));
  }
  return { getComponentContent: l };
}
function Pt(e, t) {
  e.duration && setTimeout(t, e.duration);
}
function Wt(e, t = 200) {
  let n;
  function a() {
    clearTimeout(n), n = setTimeout(e, t);
  }
  D(() => {
    addEventListener("resize", a, !1);
  }), Qe(() => {
    removeEventListener("resize", a, !1);
  });
}
function Nt(e) {
  return {
    bindPositionAdjust: () => addEventListener(ue, e, !1),
    unbindPositionAdjust: () => removeEventListener(ue, e, !1),
    triggerPositionAdjust: () => dispatchEvent(pt)
  };
}
function ze(e, t, n) {
  const a = {
    closing: () => {
      e("update:visible", !1);
    }
  };
  function l(i) {
    t(i, a);
  }
  function s() {
    n(a);
  }
  return {
    closeDialogWithCallback: l,
    closeDialogWithoutCallback: s
  };
}
function je(e, t) {
  const {
    bindPositionAdjust: n,
    unbindPositionAdjust: a,
    triggerPositionAdjust: l
  } = Nt(e);
  function s(i) {
    a(), t(i, {
      afterClose: l
    });
  }
  return n(), {
    closeGroupDialogWithCallback: s
  };
}
function He(e, { attrs: t, slots: n }) {
  const a = p(!1), { index: l, key: s } = We(), i = {
    dialogKey: s,
    dialogIndex: l,
    onRenderDialog: (c) => {
      a.value = c;
    }
  };
  return () => {
    if (!(!t.visible && !a.value))
      return Ae(e, de(t, i), () => n.default());
  };
}
function Re(e, t) {
  const n = t.offset || Be;
  function a() {
    return K.value.filter((s) => s.type === e && s.placement === t.placement && s.index < t.dialogIndex);
  }
  function l() {
    const s = a();
    if (!s.length) return n;
    let i = 0;
    return s.forEach((c) => {
      const r = document.getElementById(c.key);
      i += r.offsetHeight + rt;
    }), n + i;
  }
  return { getVerticalPosition: l };
}
function Z(e, t) {
  const n = p(!1), a = p(!1), l = p(0), s = p(0), i = p(), c = p(), r = p(!1), u = p(!0), f = p(!0), d = p(), { dialogZIndex: m, backdropZIndex: _ } = Bt(e.dialogIndex), y = j(() => {
    const g = {};
    return typeof l.value < "u" && (g.width = q(l.value)), typeof s.value < "u" && (g.height = q(s.value)), typeof i.value < "u" && (g.top = q(i.value)), typeof c.value < "u" && (g.bottom = q(c.value)), g;
  });
  function w(g) {
    return typeof g < "u" ? g : Mt(s.value);
  }
  function b(g, L) {
    l.value = g, s.value = L;
  }
  function T(g, L) {
    i.value = w(g), typeof L < "u" && (c.value = L);
  }
  function $() {
    n.value = !0, t(re, !0), u.value && Ot();
  }
  function E(g, L, k) {
    var De;
    r.value && (n.value = !1, (De = k == null ? void 0 : k.closing) == null || De.call(k), d.value = () => {
      var ke;
      t(Pe, g, L), (ke = k == null ? void 0 : k.afterClose) == null || ke.call(k), t(re, !1), u.value && Lt();
    });
  }
  function P(g, L) {
    E(e.callback, g, L);
  }
  function W(g) {
    E(void 0, void 0, g);
  }
  function N(g) {
    f.value && Wt(g), et(() => {
      g();
    });
  }
  function Ue(g) {
    D(() => {
      Pt(e, g);
    });
  }
  function qe() {
    r.value = !0;
  }
  function Xe() {
    d.value && d.value();
  }
  return {
    show: n,
    shaking: a,
    transitionEnterComplete: r,
    shouldControlOverflow: u,
    shouldHandleResize: f,
    dialogStyles: y,
    dialogZIndex: m,
    backdropZIndex: _,
    openDialog: $,
    destroy: d,
    closeDialog: E,
    closeWithCallback: P,
    closeWithoutCallback: W,
    setPosition: T,
    setDialogSize: b,
    setupAutomaticClose: Ue,
    setupPositionAdjustBehavior: N,
    onTransitionAfterEnter: qe,
    onTransitionAfterLeave: Xe
  };
}
const oe = /* @__PURE__ */ A({
  name: "DialogContainer",
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: ""
    },
    backdropClass: {
      type: [String, Array, Object],
      default: ""
    },
    transitionName: {
      type: String,
      default: ""
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    }
  },
  setup(e, {
    slots: t
  }) {
    const {
      show: n,
      shaking: a,
      backdrop: l,
      backdropClose: s,
      shake: i,
      dialogZIndex: c,
      backdropZIndex: r,
      onTransitionAfterEnter: u,
      onTransitionAfterLeave: f,
      backdropCloseDialog: d = void 0
    } = C(h);
    function m() {
      if (l) {
        if (s) return d && d();
        i && (a.value || (a.value = !0, setTimeout(() => {
          a.value = !1;
        }, 750)));
      }
    }
    const _ = (b) => {
      b.target === b.currentTarget && m();
    };
    function y() {
      if (!l) return;
      const b = ["v-dialog-overlay", e.backdropClass, {
        "v-dialog-overlay--embedded": e.appendTo !== "body"
      }];
      return o(ie, {
        to: e.appendTo
      }, {
        default: () => [o(ce, {
          name: "v-dialog--fade",
          appear: !0
        }, {
          default: () => n.value && o("div", {
            class: b,
            style: {
              "z-index": r
            },
            onClick: _
          }, null)
        })]
      });
    }
    function w() {
      const b = [e.containerClass, {
        "v-dialog--embedded": e.appendTo !== "body"
      }], T = {
        "z-index": c
      };
      return o(ie, {
        to: e.appendTo
      }, {
        default: () => [o("div", {
          class: ["v-dialog", b],
          style: T,
          onClick: _
        }, [o(ce, {
          name: e.transitionName,
          onAfterEnter: u,
          onAfterLeave: f,
          appear: !0
        }, {
          default: () => n.value && t.default && t.default()
        })])]
      });
    }
    return () => [y(), w()];
  }
}), ae = {
  name: "DialogContentBox",
  props: {
    className: {
      type: [String, Array, Object],
      default: ""
    }
  },
  setup(e, {
    slots: t
  }) {
    const {
      shaking: n,
      customClass: a,
      dialogStyles: l
    } = C(h), s = j(() => ["v-dialog-content", e.className, a, {
      "v-dialog--buzz-out": n.value
    }]), i = j(() => ({
      ...l.value
    }));
    return () => o("div", {
      class: s.value,
      style: i.value
    }, [t.default && t.default()]);
  }
}, O = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, l] of t)
    n[a] = l;
  return n;
}, zt = {}, jt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "v-dialog-icon bi-x-lg",
  viewBox: "0 0 16 16"
}, Ht = /* @__PURE__ */ v("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" }, null, -1), Rt = [
  Ht
];
function Gt(e, t) {
  return S(), x("svg", jt, Rt);
}
const le = /* @__PURE__ */ O(zt, [["render", Gt]]), Ft = {}, Vt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "v-dialog-icon bi-square",
  viewBox: "0 0 16 16"
}, Zt = /* @__PURE__ */ v("path", { d: "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" }, null, -1), Kt = [
  Zt
];
function Yt(e, t) {
  return S(), x("svg", Vt, Kt);
}
const Ut = /* @__PURE__ */ O(Ft, [["render", Yt]]), qt = {}, Xt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "v-dialog-icon bi-arrows-angle-contract",
  viewBox: "0 0 16 16"
}, Jt = /* @__PURE__ */ v("path", {
  "fill-rule": "evenodd",
  d: "M.172 15.828a.5.5 0 0 0 .707 0l4.096-4.096V14.5a.5.5 0 1 0 1 0v-3.975a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0 0 1h2.768L.172 15.121a.5.5 0 0 0 0 .707zM15.828.172a.5.5 0 0 0-.707 0l-4.096 4.096V1.5a.5.5 0 1 0-1 0v3.975a.5.5 0 0 0 .5.5H14.5a.5.5 0 0 0 0-1h-2.768L15.828.879a.5.5 0 0 0 0-.707z"
}, null, -1), Qt = [
  Jt
];
function en(e, t) {
  return S(), x("svg", Xt, Qt);
}
const tn = /* @__PURE__ */ O(qt, [["render", en]]), nn = {
  setup() {
    const {
      maxButton: e,
      maximize: t,
      title: n,
      closeButton: a,
      switchMaximize: l,
      closeDialogWithoutCallback: s
    } = C(h);
    return () => o("div", {
      class: "v-dialog-header"
    }, [o("h3", null, [n]), e && o("button", {
      type: "button",
      class: "v-dialog-btn__maximize",
      onClick: l
    }, [t.value ? o(tn, null, null) : o(Ut, null, null)]), a && o("button", {
      type: "button",
      class: "v-dialog-btn__close",
      onClick: s
    }, [o(le, null, null)])]);
  }
}, te = {
  name: "DialogComponentBody",
  setup(e, {
    slots: t
  }) {
    const {
      getComponentContent: n
    } = $t(t);
    return () => o("div", {
      class: "v-dialog-body"
    }, [n()]);
  }
};
function on(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Object]" && !X(e);
}
const Ge = /* @__PURE__ */ A({
  name: "DialogModal",
  props: F({
    /**
     * The component to put in the Modal
     */
    component: [Function, Object],
    shake: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      default: "Dialog"
    },
    width: {
      type: Number,
      default: Ie
    },
    height: {
      type: Number,
      default: Oe
    },
    /**
     * The parameters pass to Component as props
     */
    params: Object,
    /** Open maximized dialog */
    fullscreen: {
      type: Boolean,
      default: !1
    },
    maxButton: {
      type: Boolean,
      default: !0
    },
    closeButton: {
      type: Boolean,
      default: !0
    },
    visible: {
      type: Boolean,
      default: !1
    }
  }),
  emits: V(["update:visible"]),
  setup(e, {
    emit: t,
    slots: n,
    expose: a
  }) {
    const {
      maximize: l,
      closeDialogWithoutCallback: s,
      ...i
    } = an(e, t);
    H(h, {
      ...e,
      ...i,
      ...Et,
      closeDialogWithoutCallback: s,
      maximize: l
    });
    const c = j(() => ["v-dialog-modal", "v-dialog--content-center", {
      "v-dialog-modal--maximize": l.value
    }]);
    return a({
      close: s
    }), () => {
      let r;
      return o(oe, {
        "container-class": c.value,
        "transition-name": "v-dialog--smooth"
      }, {
        default: () => [o(ae, null, {
          default: () => [e.header && o(nn, null, null), n.default ? o(te, null, on(r = n.default()) ? r : {
            default: () => [r]
          }) : o(te, null, null)]
        })]
      });
    };
  }
});
function an(e, t) {
  const {
    setDialogSize: n,
    openDialog: a,
    closeWithCallback: l,
    closeWithoutCallback: s,
    ...i
  } = Z(e, t), c = p(!1), {
    closeDialogWithCallback: r,
    closeDialogWithoutCallback: u
  } = ze(t, l, s);
  Se(() => e.visible, (m) => {
    m || u();
  });
  function f() {
    c.value = !c.value;
  }
  function d() {
    a(), e.fullscreen && f();
  }
  return n(e.width || Ie, e.height || Oe), D(() => {
    d();
  }), {
    ...i,
    maximize: c,
    openModal: d,
    switchMaximize: f,
    closeDialogWithCallback: r,
    closeDialogWithoutCallback: u,
    backdropCloseDialog: u
  };
}
function ln(e, t = {}) {
  const n = {
    ...t,
    component: xe(e)
  };
  return z(Ge, n);
}
const sn = {}, cn = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  class: "v-dialog-icon v-dialog-icon-loading"
}, rn = /* @__PURE__ */ v("path", {
  d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
  opacity: ".25"
}, null, -1), un = /* @__PURE__ */ v("path", { d: "M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" }, [
  /* @__PURE__ */ v("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "0.75s",
    values: "0 12 12;360 12 12",
    repeatCount: "indefinite"
  })
], -1), dn = [
  rn,
  un
];
function fn(e, t) {
  return S(), x("svg", cn, dn);
}
const gn = /* @__PURE__ */ O(sn, [["render", fn]]), mn = {
  name: "DialogMaskBody",
  setup(e, {
    slots: t
  }) {
    const {
      icon: n
    } = C(h);
    return () => o("div", {
      class: "v-dialog-body"
    }, [n && o("div", {
      class: "v-dialog-mask__icon"
    }, [o(gn, null, null)]), o("div", {
      class: "v-dialog-mask__content"
    }, [t.default && t.default()])]);
  }
}, hn = /* @__PURE__ */ A({
  name: "DialogMask",
  props: F({
    appendTo: {
      type: String,
      default: "body"
    },
    pill: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: Boolean,
      default: !0
    },
    panel: {
      type: Boolean,
      default: !0
    }
  }),
  emits: V(),
  setup(e, {
    emit: t,
    expose: n
  }) {
    const {
      messageText: a,
      closeMaskWithCallback: l,
      ...s
    } = pn(e, t);
    H(h, {
      ...e,
      ...s,
      ...At
    });
    const i = ["v-dialog-mask", "v-dialog--content-center"], c = [{
      "mask--pill": e.pill,
      "mask--no-icon": !e.icon,
      "mask--no-panel": !e.panel
    }];
    return n({
      close: l
    }), () => o(oe, {
      "container-class": i,
      "backdrop-class": {
        "v-dialog-overlay--blur": !e.panel
      },
      "transition-name": "v-dialog--smooth",
      "append-to": e.appendTo
    }, {
      default: () => [o(ae, {
        "class-name": c
      }, {
        default: () => [o(mn, null, {
          default: () => a.value
        })]
      })]
    });
  }
});
function pn(e, t) {
  const {
    shouldControlOverflow: n,
    shouldHandleResize: a,
    setDialogSize: l,
    openDialog: s,
    closeWithCallback: i,
    ...c
  } = Z(e, t), {
    addParentRelative: r,
    removeParentRelative: u
  } = vn(e.appendTo), f = pe(e.language), d = j(() => e.message || f.maskText);
  e.appendTo !== "body" && (a.value = !1, n.value = !1);
  function m() {
    i(void 0, {
      afterClose: () => u
    });
  }
  return r(), l(void 0, 60), D(() => {
    s();
  }), {
    ...c,
    messageText: d,
    closeMaskWithCallback: m
  };
}
function vn(e) {
  const t = n();
  function n() {
    if (typeof e == "string")
      return document.querySelector(e);
    if (xt(e))
      return e;
  }
  function a() {
    e !== "body" && t.classList.add("v-dialog-mask-parent--relative");
  }
  function l() {
    e !== "body" && t.classList.remove("v-dialog-mask-parent--relative");
  }
  return {
    addParentRelative: a,
    removeParentRelative: l
  };
}
function _n() {
  return z(hn, U(...arguments));
}
const yn = {
  setup() {
    const {
      title: e,
      closeButton: t,
      closeDialogWithoutCallback: n
    } = C(h);
    return () => o("div", {
      class: "v-dialog-header"
    }, [o("h3", null, [e]), t && o("button", {
      type: "button",
      class: "v-dialog-btn__close",
      onClick: n
    }, [o(le, null, null)])]);
  }
};
function bn(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Object]" && !X(e);
}
const Fe = /* @__PURE__ */ A({
  name: "DialogDrawer",
  props: F({
    /**
     * The component to put in the Drawer
     */
    component: [Function, Object],
    title: {
      type: String,
      default: "Dialog"
    },
    width: {
      type: Number,
      default: void 0
    },
    height: {
      type: Number,
      default: void 0
    },
    backdropClose: {
      type: Boolean,
      default: !0
    },
    /**
     * The parameters pass to Component as props
     */
    params: Object,
    closeButton: {
      type: Boolean,
      default: !0
    },
    placement: {
      type: String,
      default: J
    },
    visible: {
      type: Boolean,
      default: !1
    }
  }),
  emits: V(["update:visible"]),
  setup(e, {
    emit: t,
    slots: n,
    expose: a
  }) {
    const {
      getPositionClass: l,
      getTransitionName: s,
      closeDialogWithoutCallback: i,
      ...c
    } = Cn(e, t);
    H(h, {
      ...e,
      ...c,
      ...St,
      closeDialogWithoutCallback: i
    });
    const r = j(() => ["v-dialog-drawer", l()]);
    return a({
      close: i
    }), () => {
      let u;
      return o(oe, {
        "container-class": r.value,
        "transition-name": s()
      }, {
        default: () => [o(ae, null, {
          default: () => [e.header && o(yn, null, null), n.default ? o(te, null, bn(u = n.default()) ? u : {
            default: () => [u]
          }) : o(te, null, null)]
        })]
      });
    };
  }
});
function Cn(e, t) {
  const {
    setDialogSize: n,
    openDialog: a,
    closeWithCallback: l,
    closeWithoutCallback: s,
    ...i
  } = Z(e, t), { placement: c } = e, { width: r, height: u } = Dn(e), {
    closeDialogWithCallback: f,
    closeDialogWithoutCallback: d
  } = ze(t, l, s);
  Se(() => e.visible, (y) => {
    y || d();
  });
  function m() {
    return "v-dialog-drawer--" + (Te.includes(c) ? c : J);
  }
  function _() {
    return "v-dialog-drawer-slide-in-" + (Te.includes(c) ? c : J);
  }
  return n(r, u), D(() => {
    a();
  }), {
    ...i,
    getPositionClass: m,
    getTransitionName: _,
    closeDialogWithCallback: f,
    closeDialogWithoutCallback: d,
    backdropCloseDialog: d
  };
}
function Dn(e) {
  const { width: t, height: n, placement: a } = e, l = t || dt, s = n || ft;
  return a === G || a === fe ? { width: lt, height: s } : { width: l, height: st };
}
function kn(e, t = {}) {
  const n = {
    ...t,
    component: xe(e)
  };
  return z(Fe, n);
}
const wn = {
  name: "DialogAlertHeader",
  setup() {
    const {
      title: e,
      lang: t,
      messageType: n
    } = C(h), a = e || Ne(n, t);
    return () => o("div", {
      class: "v-dialog-header"
    }, [o("h3", null, [a])]);
  }
}, Tn = {}, En = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "v-dialog-icon bi-info-circle",
  viewBox: "0 0 16 16"
}, An = /* @__PURE__ */ v("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }, null, -1), Sn = /* @__PURE__ */ v("path", { d: "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" }, null, -1), xn = [
  An,
  Sn
];
function Mn(e, t) {
  return S(), x("svg", En, xn);
}
const _e = /* @__PURE__ */ O(Tn, [["render", Mn]]), Bn = {}, In = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "v-dialog-icon bi-exclamation-triangle",
  viewBox: "0 0 16 16"
}, On = /* @__PURE__ */ v("path", { d: "M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" }, null, -1), Ln = /* @__PURE__ */ v("path", { d: "M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" }, null, -1), $n = [
  On,
  Ln
];
function Pn(e, t) {
  return S(), x("svg", In, $n);
}
const ye = /* @__PURE__ */ O(Bn, [["render", Pn]]), Wn = {}, Nn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "v-dialog-icon bi-x-circle",
  viewBox: "0 0 16 16"
}, zn = /* @__PURE__ */ v("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }, null, -1), jn = /* @__PURE__ */ v("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" }, null, -1), Hn = [
  zn,
  jn
];
function Rn(e, t) {
  return S(), x("svg", Nn, Hn);
}
const be = /* @__PURE__ */ O(Wn, [["render", Rn]]), Gn = {}, Fn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "v-dialog-icon bi-check-circle",
  viewBox: "0 0 16 16"
}, Vn = /* @__PURE__ */ v("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }, null, -1), Zn = /* @__PURE__ */ v("path", { d: "M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" }, null, -1), Kn = [
  Vn,
  Zn
];
function Yn(e, t) {
  return S(), x("svg", Fn, Kn);
}
const Ce = /* @__PURE__ */ O(Gn, [["render", Yn]]), Un = {}, qn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "v-dialog-icon bi-question-circle",
  viewBox: "0 0 16 16"
}, Xn = /* @__PURE__ */ v("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }, null, -1), Jn = /* @__PURE__ */ v("path", { d: "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" }, null, -1), Qn = [
  Xn,
  Jn
];
function eo(e, t) {
  return S(), x("svg", qn, Qn);
}
const to = /* @__PURE__ */ O(Un, [["render", eo]]), no = {
  name: "DialogAlertBody",
  setup() {
    const {
      icon: e,
      message: t,
      messageType: n,
      getAlertTypeClass: a
    } = C(h), l = ["v-dialog-body", a(n)];
    function s(i) {
      switch (i) {
        case R:
          return o(_e, null, null);
        case M:
          return o(ye, null, null);
        case B:
          return o(be, null, null);
        case I:
          return o(Ce, null, null);
        case Y:
          return o(to, null, null);
        default:
          return;
      }
    }
    return e || l.push("no-icon"), () => o("div", {
      class: l
    }, [o("div", {
      class: "v-dialog-alert__content"
    }, [e && o("div", {
      class: "v-dialog-alert__icon"
    }, [s(n)]), o("div", {
      class: "v-dialog-alert__message"
    }, [t])])]);
  }
}, oo = {
  name: "DialogAlertFooter",
  setup() {
    const e = p(), {
      lang: t,
      cancelAlert: n,
      isConfirmType: a,
      closeWithCallback: l
    } = C(h);
    return D(() => {
      e.value && e.value.focus();
    }), () => o("div", {
      class: "v-dialog-footer"
    }, [o("div", {
      class: "v-dialog-alert__buttons"
    }, [o("button", {
      type: "button",
      class: "v-dialog-btn__ok",
      ref: e,
      onClick: l
    }, [t.btnOk]), a() && o("button", {
      type: "button",
      class: "v-dialog-btn__cancel",
      onClick: n
    }, [t.btnCancel])])]);
  }
}, Ve = /* @__PURE__ */ A({
  name: "DialogAlert",
  props: F({
    /**
     * Message type
     *
     * - `info` - default
     * - `warning`
     * - `error`
     * - `success`
     * - `confirm`
     */
    messageType: {
      type: String,
      default: R
    },
    colorfulShadow: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: Boolean,
      default: !0
    },
    cancelCallback: {
      type: Function,
      default: void 0
    }
  }),
  emits: V(),
  setup(e, {
    emit: t,
    expose: n
  }) {
    const {
      getShadowClass: a,
      closeWithCallback: l,
      ...s
    } = ao(e, t);
    return H(h, {
      ...e,
      ...s,
      ...Tt,
      closeWithCallback: l
    }), n({
      close: l
    }), () => o(oe, {
      "container-class": ["v-dialog--content-center", "v-dialog-alert", {
        "no-header": !e.header
      }],
      "transition-name": "v-dialog--candy"
    }, {
      default: () => [o(ae, {
        "class-name": [a()]
      }, {
        default: () => [e.header && o(wn, null, null), o(no, null, null), o(oo, null, null)]
      })]
    });
  }
});
function ao(e, t) {
  const { messageType: n, colorfulShadow: a } = e, {
    setDialogSize: l,
    openDialog: s,
    closeDialog: i,
    closeWithCallback: c,
    ...r
  } = Z(e, t), u = pe(e.language);
  l(it, ct);
  const f = () => Y === n;
  function d() {
    return [
      M,
      B,
      I,
      Y
    ].includes(n) ? `alert-${n}` : "";
  }
  function m() {
    return !a || !ht.includes(n) ? "" : `v-dialog__shadow--${n == null ? void 0 : n.toLowerCase()}`;
  }
  function _() {
    i(e.cancelCallback);
  }
  return D(() => {
    s();
  }), {
    ...r,
    lang: u,
    cancelAlert: _,
    isConfirmType: f,
    getAlertTypeClass: d,
    closeWithCallback: c,
    backdropCloseDialog: c,
    getShadowClass: m
  };
}
function lo() {
  return z(Ve, U(...arguments));
}
const {
  DialogAlertInfo: Co,
  DialogAlertWarning: Do,
  DialogAlertError: ko,
  DialogAlertSuccess: wo,
  DialogAlertConfirm: To
} = ve(
  [...ge, Y],
  "DialogAlert",
  Ve
), so = {
  name: "DialogMessageBody",
  setup() {
    const {
      icon: e,
      pill: t,
      message: n,
      messageType: a,
      closeButton: l,
      closeGroupDialogWithCallback: s
    } = C(h), i = ["v-dialog-body", t && "v-dialog-message--pill", e || "v-dialog-message--no-icon", co(a)];
    function c(r) {
      switch (r) {
        case R:
          return o(_e, null, null);
        case M:
          return o(ye, null, null);
        case B:
          return o(be, null, null);
        case I:
          return o(Ce, null, null);
        default:
          return;
      }
    }
    return () => o("div", {
      class: i
    }, [e && o("div", {
      class: "v-dialog-message__prepend"
    }, [c(a)]), o("div", {
      class: "v-dialog-message__body"
    }, [n]), l && o("div", {
      class: "v-dialog-message__append",
      onClick: s
    }, [o(le, {
      class: "v-dialog-message__close"
    }, null)])]);
  }
}, Ze = {
  name: "DialogLiteContainer",
  props: {
    id: {
      type: [String, Number],
      default: ""
    },
    containerClass: {
      type: [String, Array, Object],
      default: ""
    },
    transitionName: {
      type: String,
      default: ""
    }
  },
  setup(e, {
    slots: t
  }) {
    const {
      show: n,
      dialogStyles: a,
      dialogZIndex: l,
      customClass: s,
      onTransitionAfterEnter: i,
      onTransitionAfterLeave: c
    } = C(h), r = ["v-dialog-lite", e.containerClass, s];
    return () => o(ie, {
      to: "body"
    }, {
      default: () => [o("div", {
        id: e.id,
        class: r,
        style: {
          ...a.value,
          "z-index": l
        }
      }, [o(ce, {
        name: e.transitionName,
        onAfterEnter: i,
        onAfterLeave: c,
        appear: !0
      }, {
        default: () => n.value && t.default && t.default()
      })])]
    });
  }
}, Ke = /* @__PURE__ */ A({
  name: "DialogMessage",
  props: F({
    /**
     * Message type
     *
     * - `info` - default
     * - `warning`
     * - `error`
     * - `success`
     */
    messageType: {
      type: String,
      default: R
    },
    icon: {
      type: Boolean,
      default: !0
    },
    closeButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Auto close dialog milliseconds
     * - 0: disabled automatic close
     * - number of milliseconds: specify times to automatic close dialog
     */
    duration: {
      type: Number,
      default: 3e3
    },
    offset: {
      type: [String, Number],
      default: Be
    },
    placement: {
      type: String,
      default: G
    },
    /** Pill style border */
    pill: {
      type: Boolean,
      default: !0
    }
  }),
  emits: V(),
  setup(e, {
    emit: t,
    expose: n
  }) {
    const {
      handleBodyRounded: a,
      closeGroupDialogWithCallback: l,
      ...s
    } = io(e, t), i = p();
    return H(h, {
      ...e,
      ...s,
      closeGroupDialogWithCallback: l
    }), a(i), n({
      close: l
    }), () => o(Ze, {
      "container-class": ["v-dialog-message"],
      "transition-name": "v-dialog--fade-lite",
      id: e.dialogKey
    }, {
      default: () => [o(so, {
        ref: i
      }, null)]
    });
  }
});
function io(e, t) {
  const {
    setPosition: n,
    setDialogSize: a,
    openDialog: l,
    closeWithCallback: s,
    shouldHandleResize: i,
    shouldControlOverflow: c,
    setupAutomaticClose: r,
    setupPositionAdjustBehavior: u,
    ...f
  } = Z(e, t), { closeGroupDialogWithCallback: d } = je(w, s), { getVerticalPosition: m } = Re(he, e);
  i.value = !1, c.value = !1;
  function _() {
    if (e.placement !== fe)
      return m();
  }
  function y() {
    if (e.placement !== G)
      return m();
  }
  function w() {
    n(_(), y());
  }
  function b(T) {
    e.pill && D(() => {
      Me(() => {
        var $, E, P, W, N;
        ((E = ($ = T.value) == null ? void 0 : $.$el) == null ? void 0 : E.offsetHeight) > 60 && ((N = (W = (P = T.value) == null ? void 0 : P.$el) == null ? void 0 : W.classList) == null || N.remove("v-dialog-message--pill"));
      });
    });
  }
  return a(), u(w), r(d), D(() => {
    l();
  }), {
    ...f,
    handleBodyRounded: b,
    closeGroupDialogWithCallback: d
  };
}
function co(e) {
  return [
    M,
    B,
    I
  ].includes(e) ? `message-${e}` : "";
}
function ro() {
  const e = U(...arguments), t = {
    type: he,
    placement: e.placement || G
  };
  return z(Ke, e, t);
}
const {
  DialogMessageInfo: Eo,
  DialogMessageWarning: Ao,
  DialogMessageError: So,
  DialogMessageSuccess: xo
} = ve(
  ge,
  "DialogMessage",
  Ke,
  (e) => ({
    type: he,
    placement: e.placement || G
  })
), uo = {
  name: "DialogMessageBody",
  setup() {
    const {
      icon: e,
      message: t,
      messageType: n,
      header: a,
      title: l,
      lang: s,
      closeButton: i,
      closeGroupDialogWithCallback: c
    } = C(h), r = ["v-dialog-body", go(n)], u = l || Ne(n, s);
    function f(d) {
      switch (d) {
        case R:
          return o(_e, null, null);
        case M:
          return o(ye, null, null);
        case B:
          return o(be, null, null);
        case I:
          return o(Ce, null, null);
        default:
          return;
      }
    }
    return () => o("div", {
      class: r
    }, [e && o("div", {
      class: "v-dialog-toast__prepend"
    }, [f(n)]), o("div", {
      class: "v-dialog-toast__body"
    }, [a && o("h3", null, [u]), o("div", null, [t])]), i && o("div", {
      class: "v-dialog-toast__append",
      onClick: c
    }, [o(le, {
      class: "v-dialog-toast__close"
    }, null)])]);
  }
}, Ye = /* @__PURE__ */ A({
  name: "DialogToast",
  props: F({
    /**
     * Message type
     *
     * - `info` - default
     * - `warning`
     * - `error`
     * - `success`
     */
    messageType: {
      type: String,
      default: R
    },
    icon: {
      type: Boolean,
      default: !0
    },
    closeButton: {
      type: Boolean,
      default: !0
    },
    duration: {
      type: Number,
      default: 3e3
    },
    offset: {
      type: [String, Number],
      default: ut
    },
    placement: {
      type: String,
      default: ne
    }
  }),
  emits: V(),
  setup(e, {
    emit: t,
    expose: n
  }) {
    const {
      closeGroupDialogWithCallback: a,
      ...l
    } = fo(e, t), s = p();
    H(h, {
      ...e,
      ...l,
      closeGroupDialogWithCallback: a
    });
    const i = ["v-dialog-toast", mo(e.placement)];
    return n({
      close: a
    }), () => o(Ze, {
      "container-class": i,
      "transition-name": "v-dialog--fade-lite",
      id: e.dialogKey
    }, {
      default: () => [o(uo, {
        ref: s
      }, null)]
    });
  }
});
function fo(e, t) {
  const {
    setPosition: n,
    setDialogSize: a,
    openDialog: l,
    closeWithCallback: s,
    shouldHandleResize: i,
    shouldControlOverflow: c,
    setupAutomaticClose: r,
    setupPositionAdjustBehavior: u,
    ...f
  } = Z(e, t), { closeGroupDialogWithCallback: d } = je(w, s), { getVerticalPosition: m } = Re(me, e);
  i.value = !1, c.value = !1;
  function _() {
    if (e.placement !== $e && e.placement !== mt)
      return m();
  }
  function y() {
    if (e.placement !== Le && e.placement !== ne)
      return m();
  }
  function w() {
    n(_(), y());
  }
  function b(T) {
    e.pill && D(() => {
      Me(() => {
        var $, E, P, W, N;
        ((E = ($ = T.value) == null ? void 0 : $.$el) == null ? void 0 : E.offsetHeight) > 60 && ((N = (W = (P = T.value) == null ? void 0 : P.$el) == null ? void 0 : W.classList) == null || N.remove("v-dialog-message--pill"));
      });
    });
  }
  return a(), u(w), r(d), D(() => {
    l();
  }), {
    ...f,
    lang: pe(e.language),
    handleBodyRounded: b,
    closeGroupDialogWithCallback: d
  };
}
function go(e) {
  return [
    M,
    B,
    I
  ].includes(e) ? `toast-${e}` : "";
}
function mo(e) {
  const t = "v-dialog-toast--";
  return e === Le || e === $e ? t + "left" : t + "right";
}
function ho() {
  const e = U(...arguments), t = {
    type: me,
    placement: e.placement || ne
  };
  return z(Ye, e, t);
}
const {
  DialogToastInfo: Mo,
  DialogToastWarning: Bo,
  DialogToastError: Io,
  DialogToastSuccess: Oo
} = ve(
  ge,
  "DialogToast",
  Ye,
  (e) => ({
    type: me,
    placement: e.placement || ne
  })
), Lo = /* @__PURE__ */ A({
  name: "DialogModalBox",
  setup(e, t) {
    return He(Ge, t);
  }
}), $o = /* @__PURE__ */ A({
  name: "DialogDrawerBox",
  setup(e, t) {
    return He(Fe, t);
  }
}), Po = {
  install(e, t = {}) {
    const n = (t == null ? void 0 : t.instanceName) || tt, a = {
      alert: lo,
      message: ro,
      toast: ho,
      modal: ln,
      mask: _n,
      drawer: kn
    };
    e.config.globalProperties[n] = a;
  }
};
export {
  lo as DialogAlert,
  To as DialogAlertConfirm,
  ko as DialogAlertError,
  Co as DialogAlertInfo,
  wo as DialogAlertSuccess,
  Do as DialogAlertWarning,
  kn as DialogDrawer,
  $o as DialogDrawerBox,
  _n as DialogMask,
  ro as DialogMessage,
  So as DialogMessageError,
  Eo as DialogMessageInfo,
  xo as DialogMessageSuccess,
  Ao as DialogMessageWarning,
  ln as DialogModal,
  Lo as DialogModalBox,
  ho as DialogToast,
  Io as DialogToastError,
  Mo as DialogToastInfo,
  Oo as DialogToastSuccess,
  Bo as DialogToastWarning,
  Po as default
};
